import { UPDATE_ACCOUNT_TYPE_REQUEST, UPDATE_ACCOUNT_TYPE_SUCCESS, UPDATE_ACCOUNT_TYPE_FAILURE, UPDATE_ACCOUNT_TYPE_RESET, } from "../../actions";
const initialState = {
    ActivePlanData: null,
    loading: false,
    error: null,
};
const updateActiveAccountTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_ACCOUNT_TYPE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, ActivePlanData: action.payload });
        case UPDATE_ACCOUNT_TYPE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, ActivePlanData: null, error: null });
        case UPDATE_ACCOUNT_TYPE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, ActivePlanData: null });
        case UPDATE_ACCOUNT_TYPE_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, ActivePlanData: null, error: null });
        default:
            return state;
    }
};
export default updateActiveAccountTypeReducer;
